import * as Api from '@ViewModels';
import { FC } from 'react';
import { IImpersonationContext, ITagCategory } from '../../../../../extViewmodels';
import { invalidateGetTagCategoriesQuery } from '../../../../../queries/TagCategory/useGetTagCategoriesQuery';
import { useTagCategoryColorMutation } from '../../../../../queries/TagCategory/useTagCategoryColorMutation';
import { Checkbox } from '../../../../components-v2/Checkbox';
import { Pill } from '../../../../components-v2/Pill/Pill';
import { Button, ButtonBase } from '../../../../components/Button';
import { DataGridRow, DataGridRowItem } from '../../../../components/DataGrid';
import { EllipsisIcon } from '../../../../components/svgs/icons/EllipsisIcon';
import { ColorPicker } from '../ColorPicker/ColorPicker';
import { useTagsDataContext } from '../TagsContexts/TagsDataContext';
import { TagFavoriteColumn } from '../TagsFavorites/TagFavoriteColumn';
import { styleSheet } from './styles';

interface TagCategoryProps {
	category: ITagCategory;
	impersonationContext: IImpersonationContext;
	reset: () => void;
}

export const TagCategoryRow: FC<TagCategoryProps> = ({ category, impersonationContext, reset }) => {
	const { setSelectedCategory } = useTagsDataContext();

	const refreshCategories = () => {
		invalidateGetTagCategoriesQuery();
	};

	const categoryColorMutation = useTagCategoryColorMutation({
		onSuccess: refreshCategories,
	});

	const handleSelectCategory = () => {
		setSelectedCategory(category);
		reset();
	};

	return (
		<DataGridRow>
			<DataGridRowItem>
				<Checkbox disabled size='lg' />
			</DataGridRowItem>
			<DataGridRowItem>
				<TagFavoriteColumn tag={category as Api.IAccountTag} refreshTags={() => null} disabled />
			</DataGridRowItem>
			<DataGridRowItem>
				<ColorPicker
					color={category?.color}
					onColorChange={color =>
						categoryColorMutation.mutate({ categoryId: category.id, color, impersonationContext })
					}
				/>
			</DataGridRowItem>
			<DataGridRowItem /> {/** lock toggle (categories not lockable) */}
			<DataGridRowItem>
				<Pill variant='category' label={category.name} color={category.color} onClick={handleSelectCategory} />
			</DataGridRowItem>
			<DataGridRowItem>
				{category.canModifyTags && (
					<Button
						kind='reverse'
						label='Manage Category'
						size='small'
						styles={[styleSheet.noWrap]}
						onClick={handleSelectCategory}
					/>
				)}
			</DataGridRowItem>
			<DataGridRowItem /> {/** companies */}
			<DataGridRowItem /> {/** tag alerts */}
			<DataGridRowItem>
				<ButtonBase disabled>
					<EllipsisIcon />
				</ButtonBase>
			</DataGridRowItem>
		</DataGridRow>
	);
};
